import script from "./DayStreakModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DayStreakModal.vue?vue&type=script&setup=true&lang=ts"

import "./DayStreakModal.vue?vue&type=style&index=0&id=4f611bc0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f611bc0"]])

export default __exports__